module.exports = __webpack_public_path__ + "img/Dimerco_icons-Map.c8a0035a.png";